import { render, staticRenderFns } from "./childAdd.vue?vue&type=template&id=1c54d4e6&scoped=true&"
import script from "./childAdd.vue?vue&type=script&lang=js&"
export * from "./childAdd.vue?vue&type=script&lang=js&"
import style0 from "./childAdd.vue?vue&type=style&index=0&id=1c54d4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54d4e6",
  null
  
)

export default component.exports